import React from 'react';

const Services = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow-md">
      <h2 className="text-3xl font-bold mb-4 text-gray-900">Our Services</h2>
      <p className="mb-3 text-gray-700">
        We offer a wide range of software solutions and platforms tailored to your business needs, including:
      </p>
      <ul className="list-disc list-inside text-gray-700">
        <li>Custom Software Development</li>
        <li>Cloud Solutions</li>
        <li>Mobile App Development</li>
        <li>Data Analytics and AI</li>
        <li>IT Consulting</li>
      </ul>
    </div>
  );
};

export default Services;
